import { useLayoutData } from '@eneco/cms';

/**
 * A React `key` that changes whenever the flow moves to a different step page.
 *
 * Consecutive steps of the same type share a component, so without a changing
 * key React reuses the instance across the route change and the step's form
 * state travels with it. The visible symptom is the next step arriving with its
 * button already spinning, because `isSubmitSuccessful` from the step just
 * submitted is still `true` and nothing resets it.
 *
 * **Do not key on the rendering's `uid`.** That was tried and it silently does
 * nothing: `uid` identifies the *rendering definition* on the layout, and every
 * step page in a flow reuses the same one. Measured on `wetgevingskompas`,
 * `/medewerkers/` and `/omzet/` both report
 * `eacd8f74-b1cd-4b62-8c39-88b3f9d04009` for `GenericChoiceStep`. Sitecore's
 * `dataSource` did differ, because it identifies the content item, but
 * `CmsRendering` carries no equivalent and adding one would change the adapter
 * contract for both providers to express something the page path already says.
 *
 * `pagePath` comes off `CmsContext`, so it is provider-neutral and is the thing
 * that actually changes between steps.
 */
export const useStepKey = (): string => useLayoutData().pagePath;
